// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__Chshz","skeletonLoading":"Skeleton_skeletonLoading__Dp9Lc","skeletonText":"Skeleton_skeletonText__VNod7","blink":"Skeleton_blink__a21S7"};